import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles((theme) => ({
    textButton: {
        color: "#495057",
        fontWeight: 400,
        fontSize: ".875rem",
        height: "2rem",
        background: "#fff",
    },
    officialSelectModal: {
        ".mantine-Paper-root": {
            overflow: "hidden",
            borderRadius: ".5rem",
            boxShadow: "0 .875rem 2.5rem -.875rem #00000033",
        },
        ".mantine-Modal-header": {
            paddingLeft: "1.5rem",
            paddingRight: "1.5rem",
        },
        ".mantine-Modal-body": {
            paddingLeft: ".5rem",
            paddingRight: ".5rem",
        },
        ".mantine-Modal-title": {
            fontSize: "1rem",
            lineHeight: "2rem",
            fontWeight: 500,
            color: "#495057",
        },
        ".loader": {
            height: "3.125rem",
        },
        ".spinner-border": {
            borderColor: "#7259EF",
            borderRightColor: "transparent",
        },
    },
    officialCheckbox: {
        position: "absolute",
        right: "1rem",
        top: "50%",
        marginTop: "-.5rem",
    },
    officialListWrapper: {
        maxHeight: "15rem",
        overflow: "auto",
    },
    officialListFooter: {
        paddingLeft: ".5rem",
        paddingRight: ".5rem",
        paddingTop: ".5rem",
    },
    officialList: {
        overflow: "hidden",
    },
    officialItem: {
        marginLeft: "1rem",
        paddingLeft: "2.75rem",
        paddingRight: "3rem",
        marginTop: ".5rem",
        paddingBottom: ".5rem",
        float: "left",
        width: "calc(50% - 1rem)",
        position: "relative",
        minHeight: "2.60rem",
        ".image": {
            position: "absolute",
            left: 0,
            top: 0,
            width: "2rem",
            height: "2rem",
            borderRadius: "2rem",
            overflow: "hidden",
            img: {
                width: "100%",
                position: "absolute",
                top: 0,
                bottom: 0,
                left: 0,
                right: 0,
                margin: "auto",
            },
        },
        ".name": {
            fontSize: ".875rem",
            fontWeight: 500,
            lineHeight: ".875rem",
            paddingBottom: ".188rem",
            paddingTop: ".063rem",
            color: "#212529",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
        },
        ".title": {
            color: "#868E96",
            fontSize: ".75rem",
            fontWeight: 400,
            lineHeight: ".875rem",
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
        },
    },
}))
